<div class="{{colorScheme?.main}} league-table__container"
     [ngStyle]="{maxHeight: maxHeight}"
     [class.spaced]="spacedLayout"
     [class.condensed]="condensed"
     [class.small-margin]="smallTable && !expandable && leagueLogo"
     [class.hide-shadow]="hideShadow"
     *ngIf="tableData">
  <div class="league-table__row">
    <ng-container *ngIf="showLeagueName && !showAllColumnNames">
        <span *ngIf="!leagueLink" class="first-col highlight-col">{{leagueName}}</span>
        <a *ngIf="leagueLink" class="first-col highlight-col" [href]="leagueLink">{{leagueName}}</a>
    </ng-container>
    <ng-container *ngIf="!showLeagueName && !showAllColumnNames">
      <span class="first-col highlight-col">
        <img [src]="leagueLogo" alt="Liga logo" class="league-logo" style="margin-right: 8px">
        <span class="heading-text">{{ tableData.group_name }}</span>
        <mat-icon *ngIf="expandable" (click)="onToggleTable()"
                  [class.expanded]="expanded">chevron_left</mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="showAllColumnNames">
        <span class="first-col all-columns">
          <span class="highlight-col">Verein</span>
          <mat-icon *ngIf="expandable" (click)="onToggleTable()"
                    [class.expanded]="expanded">chevron_left</mat-icon>
        </span>
    </ng-container>
    <span class="col highlight-col">SP{{kroneTable ? '.' : ''}}</span>
    <span class="col highlight-col" *ngIf="!smallTable">S</span>
    <span class="col highlight-col" *ngIf="!smallTable">U</span>
    <span class="col highlight-col" *ngIf="!smallTable">N</span>
    <span class="col highlight-col wide" *ngIf="!smallTable">+/-</span>
    <span class="col highlight-col" *ngIf="!kroneTable">TD</span>
    <span class="col highlight-col">{{kroneTable ? 'Pkt.' : 'P'}}</span>
  </div>
  <ng-container *ngFor="let tableEntry of tableData.table; let i = index">
    <a class="league-table__row slide-right-on-hover" *ngIf="!rowLimit || i < rowLimit"
       [href]="getLinkOfTeam(tableEntry.readable_id)"
       [target]="openLinksInNewTab ? '_blank' : '_self'"
       [class.highlight-row]="highlightTeamId === tableEntry.teamid">
      <span class="first-col">
        <span class="placement">{{ tableEntry.pos }}</span>
        <img [src]="tableEntry.emblemUrl" alt="Team logo" class="team-logo">
        <span *ngIf="!expanded">{{ tableEntry.teamname }}</span>
        <span *ngIf="expanded">{{ tableEntry.abbreviation }}</span>
      </span>
      <span class="col">{{ tableEntry.gamesPlayed }}</span>
      <span class="col" *ngIf="!smallTable">{{ tableEntry.wins }}</span>
      <span class="col" *ngIf="!smallTable">{{ tableEntry.draws }}</span>
      <span class="col" *ngIf="!smallTable">{{ tableEntry.losses }}</span>
      <span class="col wide" *ngIf="!smallTable">{{ tableEntry.goalsFor }}:{{ tableEntry.goalsAgainst }}</span>
      <span class="col" *ngIf="!kroneTable">{{ tableEntry.goalDifference }}</span>
      <span class="col highlight-col">{{ tableEntry.points }}</span>
    </a>
  </ng-container>
  <lib-more-button
    *ngIf="showMoreButton"
    class="more-btn"
    title="GESAMT"
    [link]="leagueLink ? moreLink : null"
    [routerLink]="leagueLink ? null : moreLink"
    [colorScheme]="buttonColorScheme"
  ></lib-more-button>
</div>
<a *ngIf="expandableVert && useLinkToExpand"
   class="league-table__expand-vert"
   [target]="expandLinkTarget"
   [href]=moreLink>
  Tabelle {{rowLimit ? 'aus' : 'ein'}}klappen
  <mat-icon>arrow_drop_down</mat-icon>
</a>
<button *ngIf="expandableVert && !useLinkToExpand"
        class="league-table__expand-vert"
   [class.expanded-vert]="!rowLimit"
   (click)="onToggleExpandVert()">
  Tabelle {{rowLimit ? 'aus' : 'ein'}}klappen
  <mat-icon>arrow_drop_down</mat-icon>
</button>

